import { constants } from "../constants/redux-constants";

const initialState = {
    isConsent : false
};

const consentReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CONSENT.SET_CONSENT:
      return {
        isConsent : action.payload,
      };
    default:
      return state;
  }
};

export default consentReducer;